import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {
  ICommentList,
  IControlType,
  IDefaultAction,
  IFieldLogicAction,
  IGroupDisplayType,
  IMetadataFieldList,
  ITagDataList,
} from '../../api/types/document.type';

interface MetaDataType {
  fieldLogicAction: IFieldLogicAction[];
  controlType: IControlType[];
  defaultAction: IDefaultAction[];
  commentList: ICommentList[];
  metadataFieldList: IMetadataFieldList[];
  tagDataList: ITagDataList[];
  groupDisplayType: IGroupDisplayType[];
}
interface CodingFormState {
  metaData: MetaDataType;
}

const initialState: CodingFormState = {
  metaData: {
    fieldLogicAction: [],
    controlType: [],
    defaultAction: [],
    commentList: [],
    metadataFieldList: [],
    tagDataList: [],
    groupDisplayType: [],
  },
};

export const codingFormSlice = createSlice({
  name: 'codingForm',
  initialState,
  reducers: {
    setMetaData: (state, action: PayloadAction<MetaDataType>) => {
      if (action.payload) {
        state.metaData = action.payload;
      }
    },
  },
});

export const {setMetaData} = codingFormSlice.actions;
export default codingFormSlice.reducer;
